module.exports = __webpack_public_path__ + "static/media/candado.30a4082e.png";